import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import ThemeModeComponent from '../components/ThemeMode';
export default class ThemeMode {
  constructor() {
    _defineProperty(this, "colorSchemes", []);
  }
  add(mode, label) {
    this.colorSchemes.push({
      id: mode,
      label
    });
    return this;
  }
  extend(app, extension) {
    ThemeModeComponent.colorSchemes = Array.from(new Set([...ThemeModeComponent.colorSchemes, ...this.colorSchemes]));
  }
}
flarum.reg.add('core', 'common/extenders/ThemeMode', ThemeMode);